export const USER_FILE_TYPES = {
  IDENTITY_DOCUMENT: 'IDENTITY_DOCUMENT',
  DRIVER_LICENSE: 'DRIVER_LICENSE',
  VTC_CARD: 'VTC_CARD',
  HEALTH_INSURANCE_CARD: 'HEALTH_INSURANCE_CARD',
  CONTRACT: 'CONTRACT',
  DPAE: 'DPAE',
  URSSAF_CERTIFICATE: 'URSSAF_CERTIFICATE',
  KBIS_EXTRACT: 'KBIS_EXTRACT',
  REVTC_CERTIFICATE: 'REVTC_CERTIFICATE',
};

export const CAR_FILE_TYPES = {
  REGISTRATION: 'REGISTRATION',
  INSURANCE_CERTIFICATE: 'INSURANCE_CERTIFICATE',
  TECHNICAL_INSPECTION: 'TECHNICAL_INSPECTION',
  INSURANCE_MEMO: 'INSURANCE_MEMO',
  FRONT_PHOTO: 'FRONT_PHOTO',
  MACARON: 'MACARON',
  LIABILITY_INSURANCE: 'LIABILITY_INSURANCE',
};

export const USER_FILES = {
  personal: [
    {
      title: 'Pièce d’identité (CNI / Titre de séjour)',
      type: USER_FILE_TYPES.IDENTITY_DOCUMENT,
      expiring: true,
    },
    {
      title: 'Permis de conduire',
      type: USER_FILE_TYPES.DRIVER_LICENSE,
      expiring: true,
    },
    {
      title: 'Carte VTC',
      type: USER_FILE_TYPES.VTC_CARD,
      expiring: true,
    },
    {
      title: 'Carte vitale',
      type: USER_FILE_TYPES.HEALTH_INSURANCE_CARD,
      expiring: true,
    },
  ],
  system: [
    {
      title: 'Contrat',
      type: USER_FILE_TYPES.CONTRACT,
    },
    {
      title: 'DPAE',
      type: USER_FILE_TYPES.DPAE,
    },
    {
      title: 'Attestation Vigilance URSSAF',
      type: USER_FILE_TYPES.URSSAF_CERTIFICATE,
    },
    {
      title: 'Extrait KBIS',
      type: USER_FILE_TYPES.KBIS_EXTRACT,
    },
    {
      title: 'Attestation d’inscription au REVTC',
      type: USER_FILE_TYPES.REVTC_CERTIFICATE,
    },
  ],
};

export const CAR_FILES = [
  {
    title: 'Carte grise',
    type: CAR_FILE_TYPES.REGISTRATION,
    actionLabel: 'Ajouter un document',
  },
  {
    title: 'Assurance attestation titre onereux',
    type: CAR_FILE_TYPES.INSURANCE_CERTIFICATE,
    actionLabel: 'Ajouter un document',
    expiring: true,
  },
  {
    title: 'Contrôle technique (facultatif)',
    type: CAR_FILE_TYPES.TECHNICAL_INSPECTION,
    actionLabel: 'Ajouter un document',
  },
  {
    title: 'Mémo assurance',
    type: CAR_FILE_TYPES.INSURANCE_MEMO,
    actionLabel: 'Ajouter un document',
    expiring: true,
  },
  {
    title: 'Assurance RC Pro',
    type: CAR_FILE_TYPES.LIABILITY_INSURANCE,
    actionLabel: 'Ajouter un document',
    expiring: true,
  },
  {
    title: 'Télécharger le macaron',
    type: CAR_FILE_TYPES.MACARON,
    actionLabel: 'Ajouter un document',
  },
  {
    isPhoto: true,
    title: 'Photo avant du véhicule',
    type: CAR_FILE_TYPES.FRONT_PHOTO,
    actionLabel: 'Ajouter une photo',
    helper:
      'Veuillez télécharger une photo face avant de votre véhicule avec les plaques visibles.',
  },
];

export const FILE_KINDS = {
  USER: 'USER',
  CAR: 'CAR',
};

export const FILE_STATUS_VARIANTS = {
  PENDING: 'PENDING',
  VERIFIED: 'VERIFIED',
  EXPIRED: 'EXPIRED',
  REJECTED: 'REJECTED',
};
